<mat-list disableRipple>
  <sn-channel-list-item
    *ngFor="let item of items; trackBy: trackBy"
    [channel]="item"
    [activated]="item.id === activatedItem?.id"
    (click)="onItemTap(item)"
    (doubletap)="onItemDblTap(item)"
  >
  </sn-channel-list-item>
</mat-list>
